/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : oauthAPI.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Contains oAuth related functions.
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Dec 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            : <author>
 * On            : <date>
 * Description   : <description>
 *
 *
 ******************************************************************************/

import axios from "axios";
import {
  EnumTokenType,
  IGetAuthTokenRequestArgs,
  IGetRefreshTokenRequestArgs,
  ITokenState,
} from "models/auth";

export const getToken = async <
  T extends IGetAuthTokenRequestArgs | IGetRefreshTokenRequestArgs
>(
  args: T
): Promise<ITokenState> => {
  const { type, appConfig } = args;
  const { redirect_uri, client_id, token_endpoint } = appConfig;

  const params = new URLSearchParams();
  params.append("redirect_uri", redirect_uri);
  params.append("client_id", client_id);

  if (type === EnumTokenType.Auth) {
    params.append("grant_type", "authorization_code");
    params.append("code", (args as IGetAuthTokenRequestArgs).code);
  }

  if (type === EnumTokenType.Refresh) {
    params.append("grant_type", "refresh_token");
    params.append(
      "refresh_token",
      (args as IGetRefreshTokenRequestArgs).refresh_token
    );
  }

  const { data } = await axios.post<ITokenState>(token_endpoint, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return data;
};
